import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isAssignCalendarHolidaysToPlanzoneRequestFailure() {
      return getState().request.isFailure;
    },
    isAssignCalendarHolidaysToPlanzoneRequestPending() {
      return getState().request.isPending;
    },
    isAssignCalendarHolidaysToPlanzoneRequestSuccess() {
      return getState().request.isSuccessful;
    },
  };
}

export { createSelector };
